<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="18">
                <div class="offer-header">
                    <h4>{{offer.name}} <a class="text-muted" :href="offer.preview_url" target="_blank" v-if="offer.preview_url"><i class="material-icons md-24">&#xe8f4;</i></a></h4>
                    <div class="tools">
                        <el-button type="primary" @click="createStream" v-if="offer.status==='active'">{{ $t('create_stream') }}</el-button>
                        <el-button type="primary" @click="requestAccess" v-if="offer.status==='required_approval'">{{ $t('request_access') }}</el-button>
                    </div>
                </div>

                <el-card shadow="never" v-loading="loading">
                    <div v-if="offer.logo"><img :src="offer.logo" style="max-width: 20%;"></div>
                    <div v-html="offer.description"></div>
                </el-card>

                <h3>{{ $t('offer_goals_title') }}</h3>

                <el-table
                        v-loading="loading"
                        :data="orderBy(offer.actions, 'payouts', -1)"
                        style="width: 100%">

                    <el-table-column
                            :label="$t('name')">
                        <template slot-scope="scope">
                            <div>{{scope.row.goal.name}}</div>
                            <div class="text-sm text-muted">{{scope.row.description}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column
                            :label="$t('payout')">
                        <template slot-scope="scope">
                            <div v-if="scope.row.payment_type==='fixed'">{{ scope.row.payouts | n(2, offer.currency.symbol) }}</div>
                          <div v-if="scope.row.payment_type==='percent'">{{ scope.row.payouts | n(2) }}%</div>
                        </template>
                    </el-table-column>

                    <el-table-column
                            :label="$t('hold')">
                        <template slot-scope="scope">
                            <div v-if="scope.row.hold_period">{{ $tc('up_today', scope.row.hold_period, { n: scope.row.hold_period }) }}</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>

<!--                    <el-table-column-->
<!--                            :label="$t('geo')">-->
<!--                        <template slot-scope="scope">-->

<!--                            <div v-for="country in limitBy(scope.row.countries, 5)" :key="country.id">-->
<!--                                <span class="flag-icon" :class="'flag-icon-' + country.id | lowercase"></span> {{ country.name}}-->
<!--                            </div>-->

<!--                            <el-popover-->
<!--                                    v-if="scope.row.countries.length > 5"-->
<!--                                    placement="right"-->
<!--                                    width="250"-->
<!--                                    trigger="click">-->
<!--                                <div style="max-height: 400px; overflow: auto">-->
<!--                                    <div v-for="country in scope.row.countries" :key="country.id">-->
<!--                                        <span class="flag-icon" :class="'flag-icon-' + country.id | lowercase"></span> {{ country.name}}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <el-button slot="reference" type="text">...</el-button>-->
<!--                            </el-popover>-->

<!--                            <div v-if="!scope.row.countries.length">{{ $t('all_countries') }}</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->

<!--                    <el-table-column-->
<!--                            :label="$t('device_type')">-->
<!--                        <template slot-scope="scope">-->
<!--                                        <div v-for="device_type in scope.row.deviceTypes" :key="device_type">-->
<!--                                        {{$t('device_types.' + device_type)}}&lt;!&ndash;span v-if="index+1 < scope.row.deviceTypes.length">, </span&ndash;&gt;-->
<!--                                        </div>-->
<!--                            <div v-if="!scope.row.deviceTypes.length">{{ $t('all_devices') }}</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->

<!--                    <el-table-column-->
<!--                            :label="$t('device_os')">-->
<!--                        <template slot-scope="scope">-->
<!--                                      <div v-for="deviceOs in scope.row.deviceOs" :key="deviceOs.id">-->
<!--                                            {{deviceOs.name}}&lt;!&ndash;span v-if="index+1 < scope.row.deviceOs.length">, </span&ndash;&gt;-->
<!--                                        </div>-->
<!--                            <div v-if="!scope.row.deviceOs.length">{{ $t('all_os') }}</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>

                <h3>{{ $t('streams') }}</h3>

                <StreamItem :offer_id="$route.params.id" ref="stream" v-on:closedForm="$router.push({ name: 'offer-view', params: { id: $route.params.id } })" />

            </el-col>
            <el-col :span="6">

                <el-card shadow="never" v-loading="loading">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('traffic_sources') }}</span>
                    </div>

                    <div v-for="source in sources" :key="source.id" class="source_item">
                        <div v-if="offer.sources.find(r => r.id === source.id)" style="color: #007F0A"><i class="material-icons md-24">check_circle_outline</i>{{source.name}}</div>
                        <div v-else style="color: #B8B8B8"><i class="material-icons md-24">block</i>{{source.name}}</div>
                    </div>
                </el-card>

                <el-card shadow="never" v-loading="loading">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('landings') }}</span>
                    </div>
                    <div v-for="landing in offer.landings" :key="landing.id">
                        <a class="text-muted" :href="landing.preview_url" target="_blank"><i class="material-icons md-24">&#xe8f4;</i> {{landing.name}}</a>
                    </div>

                </el-card>

            </el-col>
        </el-row>

        <el-dialog :title="$t('request_access_offer_title')" :visible.sync="dialogRequestAccessVisible">
            <RequestAccessOffer v-on:cancel="dialogRequestAccessVisible = false" v-on:update="getOffer()" :offer="offer" />
        </el-dialog>
    </div>
</template>

<script>
    import StreamItem from '../components/StreamItem'
    import RequestAccessOffer from "../components/RequestAccessOffer";
    export default {
        name: "OfferView",
        components: {
            RequestAccessOffer,
            StreamItem
        },
        beforeRouteEnter (to, from, next) {
            window.axios.get('/offers/' + to.params.id + '?expand=description,countries,sources,categories,landings,actions').then((res) => {
                next(vm => vm.setData(res.data))
            }).catch(() => {
              next('/offers');
            });
        },
        beforeRouteUpdate (to, from, next) {
            this.axios.get('/offers/' + to.params.id + '?expand=description,countries,sources,categories,landings,actions').then((res) => {
                this.setData(res.data)
                next()
            }).catch(() => {
              next('/offers');
            });
        },
        data () {
            return {
                offer: {
                    countries: []
                },
                loading: false,
                sources: [],
                dialogRequestAccessVisible: false
            }
        },
        created () {
            //this.getOffer();
            this.$axios.get('/traffic-sources', this.model).then((res) => {
                this.sources = res.data;
            });

        },
        computed: {
            offer_id () {
                return parseInt(this.$route.params.id)
            }
        },
        methods: {
            setData (offer) {
                this.offer = offer
            },
            getOffer () {
                this.loading = true;
                this.$axios.get('/offers/' + this.$route.params.id + '?expand=description,countries,sources,categories,landings,actions').then((res) => {
                    this.offer = res.data;
                    //this.$route.meta.title2=this.offer.name;
                    this.loading = false;

                }).catch(() => {
                    this.$router.replace({ name: 'offers' })
                })

            },
            createStream () {
                this.$refs.stream.create(this.offer_id);
            },
            requestAccess () {
                this.dialogRequestAccessVisible = true;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .geo-item {
        margin-bottom: 3px;
        span {
            margin-right: 5px;
        }
    }

    .offer-header {
        img {
            width: 10%;
            margin-right: 15px;
            /*background-color: #fff;
            padding: 2px;
            border-radius: 3px;*/
        }
        h4 {
            display:inline;
            font-size: 16px;
        }
        div {
            margin-left: 15px;
            display:inline;
        }
        margin-bottom: 15px;
    }


.el-card {
    margin-bottom:15px;

    .source_item {
        i {
            margin-right: 5px;
        }
        padding-bottom: 3px;
        padding-top: 3px;
    }
}
</style>